import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose, DialogTrigger } from "../../@/components/ui/dialog";
import { Button } from "../../@/components/ui/button";
import { toast } from "sonner";
import axios from "axios";
import { api_endpoint } from "@/constants/constant";
import { useAuth } from "@clerk/clerk-react";
import { ClipLoader } from "react-spinners";

export default function DeleteCohort({ cohortId, cohortName, onDeleted, triggerButtonProps = {}, open, onOpenChange }) {
    // const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [confirmText, setConfirmText] = useState("");
    const { getToken } = useAuth();

    const handleDelete = async () => {
        setLoading(true);
        try {
            const token = await getToken();
            if (!token) return;
            const reqConfig = {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            };

            await axios.delete(`${api_endpoint}/cohort/delete/${cohortId}`, reqConfig);
            toast.success(`Cohort "${cohortName}" deleted successfully!`);
            onOpenChange(false)
            if (onDeleted) onDeleted(cohortId);
        } catch (error) {
            toast.error(`Failed to delete cohort "${cohortName}".`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            {/* <DialogTrigger asChild>
                <Button
                    variant="outline"
                    size="sm"
                    className="text-red border-red hover:bg-blue hover:border-transparent hover:text-white"
                    {...triggerButtonProps}
                >
                    Delete Cohort
                </Button>
            </DialogTrigger> */}
            <DialogContent className="max-w-md h-auto">
                <DialogHeader>
                    <DialogTitle className="font-heading text-(--neutral-900)">Delete Cohort</DialogTitle>
                </DialogHeader>
                <div className="font-body text-(--neutral-800)">
                    Are you sure you want to delete the cohort <b>{cohortName}</b>? This action cannot be undone.
                    <div className="mt-3 text-(--color-primary) font-bold">
                        Warning: Deleting this cohort will also remove all students assigned to it.<br />
                        This may result in loss of progress and access for affected users. Please ensure you have re-assigned or informed all students before proceeding.
                    </div>
                </div>
                <div className="mt-4">
                    <label className="font-body text-sm text-(--neutral-800)">
                        Type <b>{cohortName}</b> to confirm:
                    </label>
                    <input
                        type="text"
                        value={confirmText}
                        onChange={e => setConfirmText(e.target.value)}
                        className="border rounded px-2 py-1 w-full mt-1 text-(--neutral-900)"
                        placeholder={`Type "${cohortName}"`}
                    />
                </div>
                <DialogFooter className="">
                    <DialogClose asChild>
                        <Button
                            variant="outline"
                            onClick={() => onOpenChange(false)}
                            disabled={loading}
                            className="">
                            Cancel
                        </Button>
                    </DialogClose>
                    <Button
                        variant=""
                        onClick={handleDelete}
                        className=""
                        disabled={loading || confirmText !== cohortName}
                    >
                        {loading ? (
                            <span className="flex items-center justify-center w-full">
                                <ClipLoader size={20} color="#fff" />
                            </span>
                        ) : (
                            "Delete"
                        )}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}